// gem cookies_eu
import '/usr/local/bundle/bundler/gems/cookies_eu-5ca82f08a9e2/app/assets/javascripts/cookies_eu.js'
import '/usr/local/bundle/bundler/gems/cookies_eu-5ca82f08a9e2/app/assets/stylesheets/cookies_eu.scss'
